import React from "react";
import "./newpage.css";
import HeroBaner from "../resources/bannerhero.svg";
import Newlogo from "../resources/Logo.svg";
import Banner from "../resources/insurance-partners.png";
import Footerlogo from "../resources/pollicydekhoo-Cdr-jpg-300x300 1 (1).png";
import TT from "../resources/tt.svg";
import PP from "../resources/pp.svg";
import support from "../resources/247.svg";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import hamberger from "../resources/hambarger.svg";
import cross from "../resources/cross.svg";
import CarCoverage from "../resources/Carcoverage.svg";
import Lifecoverage from "../resources/Lifecoverage.svg";
import HealthCoverage from "../resources/Healthcoverage.svg";
import Pattners1 from "../resources/Pattners1.png";
import Pattners2 from "../resources/Pattners2.png";
import Pattners3 from "../resources/Pattners3.png";
import Pattners4 from "../resources/Pattners4.png";
import Pattners5 from "../resources/Pattners5.png";
import Pattners6 from "../resources/Pattners6.png";
import health from "../resources/Policy health.png";
import incar from "../resources/Policy car.png";
import life from "../resources/Policy life.png";
import Callsupport from "../resources/callsupport.svg";
import Callback from "../resources/callbacksupport.svg";
import Whatupsupport from "../resources/whatupsupport.svg";
import Mailsupport from "../resources/mailsupport.svg";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";

const testimonials = [
  {
    name: "Robert Smith",
    feedback: "Saved me money while offering better coverage!",
    rating: 5,
  },
  {
    name: "Luna Martin",
    feedback: "Responsive, helpful, and always there when I need them.",
    rating: 5,
  },
  {
    name: "John Doe",
    feedback: "Amazing service with friendly support!",
    rating: 4,
  },
];

function Landingpagenew() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  const [toogle, settoggle] = useState(false);

  const navigate = useNavigate();
  const navigateTo = (path) => {
    navigate(path);
  };
  const [pincode, setPincode] = useState("");
  console.log(pincode, "-=-=-=-==");
  const handleNumericOnly = (event) => {
    const { value } = event.target;

    const isnot = /^[0-9]*$/.test(event.key);
    const isnot2 = /^$/.test(event.key);
    if (isnot || isnot2) {
      setPincode(value);
    } else {
      event.preventDefault();
    }
  };

  const [contact_form, setcontact_form] = useState({
    First_Name: "",
    Last_Name: "",
    Contact_Number: "",
    Email_Address: "",
    Learn_More_About: "",
  });

  const addValues = (e) => {
    setcontact_form({
      ...contact_form,
      [e.target.name]: e.target.value,
    });
    console.log(contact_form);
  };

  console.log(contact_form);

  const handlesubmit1 = async (e) => {
    console.log(contact_form);
    try {
      const response = await fetch(
        "https://policydekhoo-backend.onrender.com/Setcontactformdata",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(contact_form),
        }
      );

      if (response) {
        console.log("Data added successfully");
      } else {
        console.error("Failed to add data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const contactFormRef = useRef(null);

  // // Function to scroll to the contact form
  // const scrollToContactForm = () => {
  //   if (contactFormRef.current) {
  //     contactFormRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 2) {
    groupedTestimonials.push(testimonials.slice(i, i + 2));
  }

  return (
    <div className="backcolou">
      {/* contact info */}
      <div className="container-fluid d-none d-lg-block">
        <div className="row">
          <div className="col-sm-8 ps-5 text-start mt-4 mb-3">
            <select name="" id="" className="lang">
              <option value="">English</option>
              <option value="">Hindi</option>
            </select>
          </div>
          <div className="col-sm-2 mt-4">
            <div>
              <span>+917734007799</span>
            </div>
          </div>
          <div className="col-sm-2 mt-4 text-start">
            <div className="">info@policydekhoo.com</div>
          </div>
        </div>
      </div>

      {toogle === false ? (
        <>
          {/* Navbar */}
          <div className="container-fluid mb-5 ">
            <div className="row align-items-center">
              {/* Logo Section */}
              <div className="col-8 col-lg-3 mt-3 ps-5 d-flex align-items-center">
                <img
                  src={Newlogo}
                  alt="Logo"
                  style={{ width: "12vw", maxWidth: "50px" }}
                />
                <span className="fs-5 ms-2">Policy Dekhoo</span>
              </div>

              {/* Navigation Links */}
              <div className="col-lg-7 col-4 d-flex justify-content-end align-items-center">
                <div className="row align-items-center w-100">
                  {/* Desktop Menu */}
                  <div className="col-lg-9 d-none d-lg-block">
                    <ul className="list-inline mb-0">
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                      >
                        Home
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                      >
                        PD Advantages
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                      >
                        Customer Rating
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigateTo("/About")}
                      >
                        About Us
                      </li>
                      <li className="list-inline-item dropdown p-1 fs-6">
                        <a
                          className="nav-link dropdown-toggle"
                          href="#"
                          id="navbarDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ cursor: "pointer" }}
                        >
                          Support
                        </a>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                          style={{ minWidth: "200px" }}
                        >
                          <li>
                            <a className="dropdown-item" href="#">
                              <img src={Callsupport} className="me-2" alt="" />
                              Call Us
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="mailto:info@policydekhoo.com"
                            >
                              <img
                                src={Mailsupport}
                                className="me-2"
                                alt="Mail Support"
                              />
                              Mail Us
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="https://wa.me/lokesh"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={Whatupsupport}
                                className="me-2"
                                alt="WhatsApp Support"
                              />
                              WhatsApp
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleOpen();
                              }}
                            >
                              <img
                                src={Callback}
                                className="me-2"
                                alt="Callback Icon"
                              />
                              Call Back
                            </a>
                          </li>

                          {/* Modal */}
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style}>
                              {/* Modal Content */}
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                              >
                                Request a Call Back
                              </Typography>
                              <Box
                                component="form"
                                sx={{
                                  mt: 2,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                {/* Phone Number Input */}
                                <TextField
                                  id="phone-number"
                                  label="Phone Number"
                                  variant="outlined"
                                  fullWidth
                                  onKeyPress={handleNumericOnly}
                                  maxLength={10}
                                />

                                {/* Reason Textarea */}
                                <TextField
                                  id="reason"
                                  label="Reason"
                                  variant="outlined"
                                  fullWidth
                                  multiline
                                  rows={4}
                                />

                                {/* Buttons */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1,
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                      // Add your submission logic here
                                      handleClose();
                                    }}
                                  >
                                    Request Call
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleClose}
                                  >
                                    Close
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </Modal>
                        </ul>
                      </li>
                      <li
                        className="list-inline-item p-1 fs-6"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigateTo("/Claim")}
                      >
                        Claim
                      </li>
                    </ul>
                  </div>

                  {/* Mobile Menu */}
                  <div className="col-lg-3 col-4 d-lg-none text-end">
                    <img
                      src={hamberger}
                      alt="Menu"
                      style={{
                        cursor: "pointer",
                        width: "30px",
                        height: "30px",
                      }}
                      onClick={() => settoggle(!toogle)}
                    />
                  </div>
                </div>
              </div>

              {/* Contact Section */}
              <div className="col-lg-2 d-none d-lg-flex  justify-content-end pe-5">
                <span
                  className="fs-6 fw-bold "
                  style={{
                    cursor: "pointer",
                    borderBottom: "2px solid black", // Adjust thickness and color as needed
                    // paddingBottom: "4px",
                  }}
                >
                  Contact
                </span>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {toogle === true ? (
        <>
          <div className="container menuu">
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-8  text-start ps-5">
                    <span className="fs-3">Policy dekhoo</span>
                  </div>
                  <div className="col-4">
                    <img
                      src={cross}
                      alt=""
                      onClick={(e) => settoggle(!toogle)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-7 col-1">
                <ul
                  className=""
                  style={{ listStyle: "none", textAlign: "left" }}
                >
                  <li
                    className=" p-2  fs-6"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigateTo("/");
                    }}
                  >
                    Home
                  </li>
                  <li className=" p-2 fs-6" style={{ cursor: "pointer" }}>
                    PD Advantages
                  </li>
                  <li className="p-2 fs-6" style={{ cursor: "pointer" }}>
                    Customer Rating
                  </li>
                  <li className=" p-2 fs-6" style={{ cursor: "pointer" }} onClick={() => navigateTo("/About")}>

                    About Us
                  </li>
                  <li className="list-inline-item dropdown p-1 fs-6">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                    >
                      Support
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                      style={{ minWidth: "200px" }}
                    >
                      <li>
                        <a className="dropdown-item" href="#">
                          <img src={Callsupport} className="me-2" alt="" />
                          Call Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="mailto:info@policydekhoo.com"
                        >
                          <img
                            src={Mailsupport}
                            className="me-2"
                            alt="Mail Support"
                          />
                          Mail Us
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://wa.me/lokesh"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={Whatupsupport}
                            className="me-2"
                            alt="WhatsApp Support"
                          />
                          WhatsApp
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleOpen();
                          }}
                        >
                          <img
                            src={Callback}
                            className="me-2"
                            alt="Callback Icon"
                          />
                          Call Back
                        </a>
                      </li>

                      {/* Modal */}
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box sx={style}>
                          {/* Modal Content */}
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            Request a Call Back
                          </Typography>
                          <Box
                            component="form"
                            sx={{
                              mt: 2,
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            {/* Phone Number Input */}
                            <TextField
                              id="phone-number"
                              label="Phone Number"
                              variant="outlined"
                              fullWidth
                              // onKeyPress={handleNumericOnly}
                              maxLength={10}
                            />

                            {/* Reason Textarea */}
                            <TextField
                              id="reason"
                              label="Reason"
                              variant="outlined"
                              fullWidth
                              multiline
                              rows={4}
                            />

                            {/* Buttons */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1,
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                  // Add your submission logic here
                                  handleClose();
                                }}
                              >
                                Request Call
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleClose}
                              >
                                Close
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Modal>
                    </ul>
                  </li>
                  <li className="p-2 fs-6" style={{ cursor: "pointer" }} onClick={() => navigateTo("/Claim")}>
                    Claim
                  </li>
                </ul>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-12">
                <span className="get p-2">Contact Us</span>
              </div>
            </div>

            <div className="row fixed-bottom ">
              <div className="col-12">
                <div className=" ">
                  <span>© 2020 Policy Dekhoo | Powered by Policy Dekhoo</span>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {/* hero section */}
      {toogle === false ? (
        <>
          <div className="container-fluid ">
            <div className="row py-5 mt-5 justify-content-center ">
              <div className="  col-lg-7 col-11 p-md-5 ps-5">
                <div className="hero  ">
                  <spna className="">Security for Future with</spna>
                  <h1 className="fs-1 best">Best Insurance </h1>
                  <h2 className="fs-1">from Policy Dekhoo</h2>
                </div>
              </div>
              <div className=" col-lg-4 col-10 ">
                <div
                  id="carouselExampleInterval"
                  class="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active" data-bs-interval="1000">
                      <img src={life} class="d-block " alt="..." />
                    </div>
                    <div class="carousel-item" data-bs-interval="2000">
                      <img src={incar} class="d-block " alt="..." />
                    </div>
                    <div class="carousel-item" data-bs-interval="4000">
                      <img src={health} class="d-block " alt="..." />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleInterval"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleInterval"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/*carousel items list  */}
          {/* <div className="container-fluid p-5">
            <div className="row">
              <div className="col-sm-12">
                <div
                  id="carouselExampleCaptions"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#carouselExampleCaptions"
                      data-bs-slide-to="0"
                      className="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleCaptions"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExampleCaptions"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                  </div> */}
          {/* Carousel Items */}
          {/* <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img
                        src={HeroBaner}
                        className="d-block w-50"
                        alt="First slide"
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>First slide label</h5>
                        <p>
                          Some representative placeholder content for the first
                          slide.
                        </p>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <img
                        src={HeroBaner}
                        className="d-block w-50"
                        alt="Second slide"
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>Second slide label</h5>
                        <p>
                          Some representative placeholder content for the second
                          slide.
                        </p>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <img
                        src={HeroBaner}
                        className="d-block w-50"
                        alt="Third slide"
                      />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>Third slide label</h5>
                        <p>
                          Some representative placeholder content for the third
                          slide.
                        </p>
                      </div>
                    </div>
                  </div> */}

          {/* Controls */}
          {/* <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button> */}
          {/* </div>
              </div>
            </div>
          </div> */}

          {/* policy section */}
          <div className="container-fluid px-5 mt-5 ">
            <div className="row justify-content-center mb-4">
              <div
                className="col-3  col-lg-1   pol m-2"
                onClick={() => {
                  navigateTo("/CarForm/1");
                }}
              >
                <div className="mb-2 mt-3">
                  {/* <img src={car} alt="" style={{height:"1.4vw"}} /> */}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-2 insure"
                    viewBox="0 0 65.22 51.15"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M5.7,17.41A3,3,0,0,0,3.6,17c-1,0-1.83-.24-1.95-1.36s0-2.11,1.23-2.49c1.41-.45,2.75-1.59,4.39-.21.47.4,1.07-.51,1.32-1.22A45.51,45.51,0,0,1,11.5,4.89,7.52,7.52,0,0,1,17.77.59C25.7-.43,33.62.27,41.54,0a44,44,0,0,1,8,.9c2.46.38,3.71,2.78,4.7,5,.91,2,1.56,4.08,2.45,6.07.23.53.37,1.71,1.67.69,1.13-.89,4,.3,4.81,1.26a2.14,2.14,0,0,1,.31,2.17,1.56,1.56,0,0,1-1.68,1,3.51,3.51,0,0,0-2.25.32c1.31,1.21,2.58,2.32,3.79,3.5a5.61,5.61,0,0,1,1.84,4.37c-.09,7.49,0,15,0,22.48a3.13,3.13,0,0,1-3.47,3.43c-1.74,0-3.49,0-5.23,0-2.5,0-3.78-1.15-3.64-3.61.09-1.66-.56-2-2-1.76-9.83,1.33-19.71.46-29.57.71-2.54.06-5-.77-7.47-.75-.94,0-1.35.13-1.39,1.22-.1,3.46-.94,4.19-4.43,4.2H3.53A3.13,3.13,0,0,1,.07,47.7c0-7.3.1-14.6-.07-21.9a7,7,0,0,1,2.51-5.63C3.49,19.25,4.55,18.4,5.7,17.41Zm-1,5.9L4,24c-1.24.17-.77,1.16-.78,1.82,0,4.38.92,8.7.81,13.11-.07,2.74.86,3.3,3.69,2.63A7.46,7.46,0,0,1,6.2,36.82c.1-2.67,1.16-3.28,3.71-2.32,3,1.16,6.07,2.63,9.39,2.67,8.85.1,17.7,0,26.55,0a6.85,6.85,0,0,0,2.28-.27c2.6-.92,5.27-1.64,7.84-2.69,1.87-.76,2.89.26,3,2.34a8.05,8.05,0,0,1-1.56,5.07c2.47.77,3.85-.2,3.88-3,0-2.45-.22-4.94.33-7.34A38.65,38.65,0,0,0,62.07,25a.94.94,0,0,0-.81-1.1l-.69-.59c0-.25,0-.58-.11-.73-1.71-1.78-4-2.92-5.27-5.19-.31-.58-.92-.35-1.4-.35q-21.16,0-42.33,0c-.78,0-1.49.13-1.77.79C9.05,19.3,7.58,19.89,6.58,21,5.91,21.7,4.61,22,4.68,23.31Zm27.84-9.37c6.52,0,13,0,19.55,0,1.24,0,2-.28,1.43-1.58A31.33,31.33,0,0,0,50.32,5.6c-.53-.73-1.08-1.8-2.28-1.74-3.1.14-6.14-.55-9.22-.68a170.05,170.05,0,0,0-21.41.63A2.65,2.65,0,0,0,15.54,4.9c-2,2.19-2.75,5-3.82,7.66-.54,1.34.43,1.39,1.44,1.39C19.61,13.93,26.07,13.94,32.52,13.94ZM9.46,38a6.3,6.3,0,0,0,5.07,4.55c3,.36,6,.65,9,.75a199,199,0,0,0,26.63-.64c2.12-.21,3.58-1.67,4.86-3.26a1.18,1.18,0,0,0,0-1.08c-.33-.47-.6.15-.89.2-2.3.39-4.33,1.79-6.73,1.79H17.62a5.83,5.83,0,0,1-2.21-.43C13.54,39.08,11.55,38.61,9.46,38ZM3.4,44.44c-.77,3.62-.77,3.62,2.76,3.62.64,0,1.29,0,1.93,0s1.3.24,1.25-.71c0-.68.29-1.33-.79-1.85C6.87,44.69,5,45.43,3.4,44.44ZM59,48.06h.78c2.39,0,2.84-.57,2.31-3-.07-.29-.17-.86-.47-.66-1.53,1-3.38.22-5,1.07-1,.5-.65,1.09-.72,1.71-.1.92.58.82,1.16.83Z" />
                        <path d="M61.26,23.9c-.21,1.47.53,3-.55,4.44-.7.95-1.64,1.48-2.42,1C56.37,28.24,54.15,29,52.23,28a17.08,17.08,0,0,1-2.3-1.38,4.82,4.82,0,0,1,2.63-1.88c2.65-.64,5.23-1.57,8-1.42Z" />
                        <path d="M4.68,23.31c3.81.24,7.61.52,11,3.24-1.94,1.16-3.61,2.16-5.71,2A3.53,3.53,0,0,0,8.08,29C5.82,30.13,4,29,3.93,26.51c0-.84,0-1.68,0-2.51Z" />
                        <path d="M46.83,27.68c-.29.74-.93.82-1.59.83-2.19,0-4.39.17-6.58.12a7.44,7.44,0,0,0-5.21,1.86c-.67.58-1,.57-1.67,0a7.44,7.44,0,0,0-5.22-1.84c-2.19.05-4.38-.07-6.57-.12-.67,0-1.52-.09-1.52-.84s.9-.43,1.42-.53c6.49-1.29,13.06-.6,19.6-.79,2.29-.06,4.38,1,6.65.84A.56.56,0,0,1,46.83,27.68Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="change fs-6 text-center text-lg-start">
                  Car
                </span>
              </div>

              <div
                className="  col-lg-1 col-3 pol m-2 "
                onClick={() => {
                  navigateTo("/BikeInsurance");
                }}
              >
                {/* <img src={bike} alt="" /> */}
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="bike mt-2 insure"
                    viewBox="0 0 80.35 51.55"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M80.35,41c-.35-.05-.61,0-.74.42a14.09,14.09,0,0,1-16.7,9.82,13.66,13.66,0,0,1-10.76-9.82,14,14,0,0,1,3.28-14.49c1.13-1.24,1-4.1-.28-5-.44-.29-.86-.11-1.35.35a14.32,14.32,0,0,0-4.1,7.06,20.51,20.51,0,0,0-.48,7.3c.22,2.26-1.34,3.39-2.9,4A20.49,20.49,0,0,1,34,41.3c-1.44-.33-3,0-4.38-1-.58-.42-1.23.25-1.43,1a14.1,14.1,0,0,1-16.54,10A13.71,13.71,0,0,1,.78,41.55,14.37,14.37,0,0,1,8.45,23.77a9.68,9.68,0,0,1,4.91-1.25A4.49,4.49,0,0,0,16,22.17c-3.3-1.65-6.62-1.31-9.88-1.23A7.82,7.82,0,0,1,.93,19.18a2,2,0,0,1-.32-3.07A11.17,11.17,0,0,1,6.89,12c3.84-1.11,7.67-.55,11.5-.6,2.09,0,3.67,1.23,5,2.9,2.48,3.21,6.19,3.06,9.71,3.37.52,0,.58-.36.73-.75,2-5.19,6.13-7.08,11.34-7.18,1.68,0,3-.28,4-1.92a3,3,0,0,0-.36-3.92c-.71-.68-2.21.06-3.25.5a15,15,0,0,0-2.61,1.7,1.55,1.55,0,0,1-2.41-.35,1.57,1.57,0,0,1,.43-2.27A13.19,13.19,0,0,1,48.77,0c1.94-.17,2.76,1,3.34,2.38.75,1.79,1.28,3.68,2,5.66,2.67-1.87,5.65-1.82,8.58-1.46C64,6.77,65,8,65.59,9.21a5.67,5.67,0,0,1-5.12,8.49c-3.74,0-3.45-.1-2.13,3.28,1.06,2.72,2.28,2.17,4.57,1.76,6.35-1.13,12,1,15.87,7.39.56.93.18,2.39,1.57,2.83Zm-11.06-.6c-3.94.09-5-3.5-7.1-5.66a2.79,2.79,0,0,0-.87,3.7c1.52,3.42,4.87,4.54,7.92,1.9C71,38,71.18,36,69.71,34a4.7,4.7,0,0,0-4.61-1.42C66.21,35.33,69.63,36.87,69.29,40.39ZM51,10.65c-1.77,2.55-4.43,2-6.94,2.34-3.38.4-6.19,1.68-7.27,5.45a3.15,3.15,0,0,1-3.71,2.48c-.78-.12-1.61.06-2.4-.05-3.87-.52-7.85-.81-10.16-4.74a2.11,2.11,0,0,0-1.35-1,20.28,20.28,0,0,0-13.14.76c-.59.24-1.46.21-1.22,1.19s1.09.58,1.67.6c1.67.07,3.35,0,5,0,4.42,0,7.81,2,10.62,5.3,1.44,1.7,2.66,3.58,4,5.33a12,12,0,0,1,2.72,6.82c.05,1.06.79,1.38,1.51,1.79,1.49.86,3.26.57,4.77,1.09,3.29,1.13,6.41.39,9.55-.37a1.7,1.7,0,0,0,1.16-1.85,25,25,0,0,1,.62-7.49A16.06,16.06,0,0,1,52,19.46a2.22,2.22,0,0,0,.91-2.89C52.15,14.75,52.08,12.75,51,10.65ZM65.37,29a8,8,0,0,1,7.75,11.66c-1.83,3.75-6.47,5.14-10,3.94a8.21,8.21,0,0,1-3.91-12.21,2.76,2.76,0,0,0,.39-1.5,2,2,0,0,0-1.1-1.74c-.65-.45-1,.55-1.26.87-2.12,3.11-3.1,6.27-1.94,10.24,2,7,11,10.52,17.11,5.73,4-3.15,5.47-7.08,4.11-12.31s-8.94-9.55-13.77-7.28c-1.31.61-1,1.08-.51,1.86C63,29.64,64.38,28.74,65.37,29ZM14.67,45c-5.48.14-9.1-4.67-8.11-10A8.48,8.48,0,0,1,13.1,29c4.38-.53,7.64,1.88,8.64,4.44a7,7,0,0,0,.8,1.59c.59.76,1.46.3,2.21.34.28,0,.8-.19.53-.59-.52-.81-.24-1.75-.74-2.63-3.07-5.33-7.18-7.15-13.33-5.64C4.27,28.18.82,37.14,5.42,43.41a11,11,0,0,0,13.45,3.87,9.82,9.82,0,0,0,6.11-7c.35-1.55-.39-2.17-1.9-1.74-.82.24-1,1.06-1.23,1.65C20.51,43.5,18,44.8,14.67,45Zm-.15-3.24a5.72,5.72,0,0,0,3.6-1.66,1.08,1.08,0,0,0,.36-1.23c-.16-.5-.67-.31-1-.32-1,0-2,0-3,0a1.45,1.45,0,0,1-1.54-1.67,1.42,1.42,0,0,1,1.51-1.49c1,0,2,0,3,0,.42,0,1,.21,1.11-.49A1.22,1.22,0,0,0,18,33.72C15.65,32,14.66,31.53,11.8,33c-1.36.71-2.43,3.37-2,4.92A5.24,5.24,0,0,0,14.52,41.8ZM60,9.71c-1.38-.37-2.58.75-4,1-.37.07-1.35.78-1,1.14.51.57.09,1.72.94,1.78,1.45.11,2.69,1,4.21.92,1.76,0,2.51-.73,2.52-2.43S62,9.47,60,9.71Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6 mt-1">Bike</span>
              </div>

              <div
                className=" col-lg-1 col-3 pol  m-2"
                onClick={() => {
                  navigateTo("/HealthForm1");
                }}
              >
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-2 insure"
                    viewBox="0 0 57.42 50.51"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M57.42,20.12c-1.08.77-.69,2.1-1,3.11a28.87,28.87,0,0,1-7.16,11.63,72.92,72.92,0,0,1-12.7,10,55.19,55.19,0,0,0-6.13,4.65c-1.47,1.3-1.86,1.28-3.34,0-3.16-2.67-6.65-4.87-10-7.26C12,38.66,7.19,34.57,3.72,29.2A13.32,13.32,0,0,1,3,27.73a3,3,0,0,1,3.73,1.43A41,41,0,0,0,17,39.19c3.22,2.36,6.55,4.55,9.77,6.9.68.5,1.11,1.56,2,1.48s1.36-1,2.05-1.53c5-3.65,10.25-6.83,14.79-11a30.89,30.89,0,0,0,7.48-9.88,19.46,19.46,0,0,0,1.53-5.05A20.06,20.06,0,0,0,55.11,16,14.22,14.22,0,0,0,46.28,3.4c-6-2.35-11.71-.44-15.76,4.29-.18.21-.37.4-.55.6-1.16,1.32-1.32,1.3-2.48,0-1.82-2-3.63-4-6.32-4.93a13.23,13.23,0,0,0-7.83-.63A13.82,13.82,0,0,0,5,8.21,14.46,14.46,0,0,0,2.42,18.3a1.75,1.75,0,0,0,.17.68c.28.52.57,1.22.09,1.54a2.78,2.78,0,0,1-1.8.11C.3,20.53.17,20,.12,19.41-.46,13.29,1,7.91,5.85,3.8A15.57,15.57,0,0,1,12.21.56C18.42-1,23.59.73,27.93,5.25c.67.7,1,.66,1.62,0A14.76,14.76,0,0,1,35.94.85,15.85,15.85,0,0,1,45,.5a16,16,0,0,1,8.55,5.27,14.1,14.1,0,0,1,3.31,6.47c.07.34.19.52.56.42Z" />
                        <path d="M19.81,16.56c-.52,2.72-.95,5.11-1.43,7.48-.34,1.65-.73,3.29-1.14,4.93A1.16,1.16,0,0,1,15,29.1a46.8,46.8,0,0,1-1.72-4.53,9.13,9.13,0,0,0-.88-1.69l-.9,1.59a1.53,1.53,0,0,1-1.5.82c-2.43,0-4.87,0-7.31,0-.8,0-1.46-.22-1.47-1.12S2,23,2.81,23c1.77,0,3.54-.09,5.3,0a2,2,0,0,0,2.27-1.47,11.12,11.12,0,0,1,1.12-2.2c.31-.49.56-1,1.24-.94s.87.52,1.15,1.06c.71,1.39.91,3,1.95,4.4a9.7,9.7,0,0,0,.71-3.1c.4-2.36,1.07-4.66,1.38-7A35.3,35.3,0,0,1,19,8.93a1.09,1.09,0,0,1,1.15-.85,1.07,1.07,0,0,1,1,.8q.66,2.88,1.17,5.79c.5,2.87,1.07,5.72,1.56,8.58a23.76,23.76,0,0,1,.8,5c0,.27-.05.69.3.7a.82.82,0,0,0,.77-.52l2.91-7.77c.05-.13,0-.33.08-.41.59-.6.42-1.86,1.66-1.87s1.25,1.12,1.54,1.77c.8,1.8,1.36,3.71,2,5.57.14,0,.29,0,.31-.07,1-2.48,3-3,5.43-2.74,1.35.12,2.78.44,4.06-.9.62-.66,2-.35,2.77.75a2,2,0,0,1,.12,2.53c-.71,1.15-2.06,1.63-2.85.91-1.13-1-2.25-.95-3.48-.95-3.09,0-3.1,0-4.65,2.64-.1.16-.08.42-.2.53-.58.48-.73,1.49-1.75,1.4s-1-.89-1.26-1.51c-.53-1.27-1-2.56-1.48-3.86-.13-.37-.15-.79-.64-.81s-.43.5-.55.82c-1.33,3.4-2.67,6.79-4,10.18-.23.57-.58,1-1.25.91s-.94-.58-1.09-1.25c-.69-3.22-1.21-6.46-1.76-9.7-.36-2.08-.9-4.13-1.1-6.24C20.63,17.79,20.2,17.38,19.81,16.56Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Health</span>
              </div>
              <div
                className="  col-lg-1 col-3  pol  m-2"
                onClick={() => {
                  navigateTo("/HomeShop");
                }}
              >
                <div className="mb-2 mt-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="insure"
                    viewBox="0 0 55.9 53.41"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M3.32,21.94c-.45.3-.82.5-1.14.76-.65.51-1.27.69-1.87-.05s-.1-1.39.51-1.88c1.49-1.19,3-2.36,4.48-3.54,5.12-4,10.24-8.07,15.38-12.07,1.91-1.49,3.9-2.87,5.71-4.49,1.14-1,2.12-.81,3.31.17,3.14,2.6,6.4,5.06,9.72,7.65A7.23,7.23,0,0,0,39.58,6a1.29,1.29,0,0,1,1.5-1.47c1.26,0,2.52,0,3.78,0S46.6,5,46.58,6.2c0,2.32,0,4.65,0,7a1.78,1.78,0,0,0,.87,1.64C50,16.65,52.52,18.68,55,20.71c.63.52,1.25,1,.66,1.87s-1.34.52-2.12.06c-.32-.19-.55-.91-1-.52-.23.2-.15.8-.15,1.23,0,9.35,0,18.7,0,28.06,0,1.52-.46,2-2,2q-22.45-.06-44.92,0c-1.46,0-2-.4-2-2,0-9.25,0-18.51,0-27.77A3,3,0,0,0,3.32,21.94ZM5.84,35.41c0,4.8,0,9.6,0,14.4,0,1,.28,1.3,1.3,1.28,3.73-.06,7.46-.07,11.2,0,1.18,0,1.55-.25,1.53-1.49-.07-6.4,0-12.8-.05-19.2,0-1.07.17-1.51,1.39-1.49,4.51.09,9,.08,13.53,0,1.19,0,1.41.36,1.41,1.46,0,6.45,0,12.9,0,19.34,0,1.1.28,1.38,1.36,1.36,3.69-.07,7.37-.08,11.06,0,1.23,0,1.62-.23,1.61-1.56-.07-9-.09-18,0-27.06,0-2-.32-3.34-2.21-4.25a22.12,22.12,0,0,1-2.63-2.07,2.11,2.11,0,0,1-1-2c.06-2,0-4,0-6,0-.83.07-1.45-1.15-1.43s-1.29.44-1.21,1.37c.06.67,0,1.36,0,2s-.06,1.51-.79,1.84-1.32-.09-1.91-.56C35.67,8.66,32.1,5.9,28.56,3.09a.78.78,0,0,0-1.2,0q-5.31,4.2-10.66,8.36-5,3.86-10,7.67A2.11,2.11,0,0,0,5.81,21C5.86,25.81,5.84,30.61,5.84,35.41Zm16.29,5.72c0,3,0,5.92,0,8.87,0,.8.19,1.1,1,1.09q4.8-.08,9.6,0c.85,0,1-.29,1-1.09q0-8.79,0-17.59c0-.86-.18-1.18-1.11-1.16q-4.72.09-9.45,0c-.93,0-1.14.3-1.12,1.16C22.16,35.32,22.13,38.23,22.13,41.13Z" />
                        <path d="M31.45,40.69c-.16.64-.52,1.12-1.27,1a1.14,1.14,0,0,1,.13-2.27C31.06,39.48,31.38,39.94,31.45,40.69Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Home/ Shop</span>
              </div>
              <div
                className="  col-lg-1 col-3 pol  m-2"
                onClick={() => {
                  navigateTo("/LifeInsurance");
                }}
              >
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-2 insure"
                    viewBox="0 0 52.38 54.52"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M17.46,54.52c.05-.46-.3-.44-.6-.55-2.59-.85-5-4.11-4.86-6.75,0-.76.21-1.37,1.07-1.39s1.06.59,1.13,1.35a5.66,5.66,0,0,0,5.47,5.14A5.4,5.4,0,0,0,25,47.39c.17-7.13.07-14.27.08-21.4,0-.74-.16-.75-.94-.57a9,9,0,0,0-5.06,3.31c-.83,1-1.35,1-2.24-.08a8.92,8.92,0,0,0-7.75-3.54,9.64,9.64,0,0,0-6.84,3.46c-.43.51-.8,1-1.51.81S0,28.38,0,27.69A22.25,22.25,0,0,1,10.19,9.11,25.86,25.86,0,0,1,21.06,4.79a19.71,19.71,0,0,1,3.32-.42c.66,0,.74-.34.72-.86,0-.72,0-1.45,0-2.18S25.34,0,26.22,0s1.06.54,1.05,1.28,0,1.45,0,2.18.26.87.94.92c7.9.56,14.58,3.66,19.59,9.9a19.5,19.5,0,0,1,3.55,7,22.8,22.8,0,0,1,1,6.6c0,.65-.16,1.19-.73,1.45s-1-.13-1.43-.51A14,14,0,0,0,44,25.21a8,8,0,0,0-5.79,1.13,8.19,8.19,0,0,0-2.7,2.41,1.21,1.21,0,0,1-2.19,0A9.46,9.46,0,0,0,28,25.32c-.74-.2-.68.12-.69.51,0,.86,0,1.73,0,2.59,0,6.23-.07,12.45,0,18.67,0,2.95-2.6,6.29-5,6.91-.31.08-.5.18-.46.52ZM2.78,25.11A11.32,11.32,0,0,1,7.68,23a10.89,10.89,0,0,1,9.4,2.72c.74.69,1.2.59,1.87,0A10.31,10.31,0,0,1,24.42,23a10.75,10.75,0,0,1,9.11,2.79c.75.67,1.12.46,1.75-.06a10.86,10.86,0,0,1,6.41-2.8,10.24,10.24,0,0,1,7,2c.56.42,1,.4,1-.52a8.8,8.8,0,0,0-.52-1.79,16.49,16.49,0,0,0-3.31-6.91c-4.57-6-11-8.47-18.21-9.07a28.24,28.24,0,0,0-5.79.38,23.21,23.21,0,0,0-8.07,2.53A20.64,20.64,0,0,0,4.08,19.75,10.91,10.91,0,0,0,2.78,25.11Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Term Life</span>
              </div>
              <div
                className="col-lg-1  col-3 pol  m-2"
                onClick={() => {
                  navigateTo("/GroupInsurance");
                }}
              >
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="insure"
                    viewBox="0 0 45.08 43.12"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M16.67,28A10.48,10.48,0,0,1,18,27.42c1.85-.55,2-1.76,1.05-3.25s-2.32-2.68-2.39-4.62c0-.67-.91-.68-1.41-.85-.68-.23-1.33-.51-2-.8-1.89-.84-2.08-4.07-.74-5.32.86-.8,1.05-2.11,2-2.91.09-.08.16-.37.1-.44-.83-1-.16-1.95,0-2.94.29-1.79-.54-2.82-2.14-3.72-1.92-1.09-4.66-.22-5.39,1.6a4.2,4.2,0,0,0,0,3.08c.22.57.43,1.12-.1,1.65a.56.56,0,0,0,0,.79c1.11.88,1.32,2.36,2.34,3.34,1.29,1.25.38,4.32-1.42,5.09-1.22.53-2.48,1-3.73,1.49a3.51,3.51,0,0,0-2.17,2c-.27.75-.71,1.15-1.42.85a1.17,1.17,0,0,1-.46-1.69,5.79,5.79,0,0,1,3.31-3.11c1.13-.45,2.27-.89,3.37-1.41s1.38-1.35.6-2.33-1.18-2.2-2.06-3.12a2,2,0,0,1-.45-1.47c0-1.42.07-2.85,0-4.27C4.8,2.47,7.38.35,9.84.05c2.09-.26,3.68.81,5.3,1.72,1.39.79,2,3.75,1.38,5.58-.1.31-.27.54-.1.9a2.7,2.7,0,0,1-.64,3.13,34.9,34.9,0,0,0-1.94,2.95,1.12,1.12,0,0,0,.35,1.6,3.37,3.37,0,0,0,2.29.77c.3-.05.21-.38.24-.61.46-4.18,3.43-5.83,7.06-5.13a6.13,6.13,0,0,1,4.33,2.83,4.26,4.26,0,0,1,.35,2.11c0,.89.52.92,1.13.78,1.81-.41,2.27-1.59,1.14-3a23.16,23.16,0,0,0-1.8-2.71,2,2,0,0,1-.51-1.57c0-1.42,0-2.85,0-4.27-.11-2.64,2.35-4.62,4.66-5s3.87.72,5.55,1.7c1.39.8,2,3.76,1.38,5.58-.11.31-.28.54-.11.89a2.66,2.66,0,0,1-.64,3.13,15,15,0,0,0-1.94,3,1.34,1.34,0,0,0,.7,1.9c1.48.73,3.1,1.12,4.55,1.93A5.63,5.63,0,0,1,45,20.92a1.11,1.11,0,0,1-.52,1.56c-.66.27-1.12-.08-1.37-.77-.56-1.55-2-2-3.35-2.57s-3.09-.91-4.07-2.38c-.47-.71-.64-3.22,0-3.74,1.09-.93,1.35-2.41,2.4-3.34.1-.09.18-.37.12-.44-.82-1-.18-1.95,0-2.94.31-1.8-.52-2.83-2.12-3.73-2-1.11-4.68-.21-5.4,1.58a4.15,4.15,0,0,0,0,3.08c.21.58.42,1.12-.1,1.66a.56.56,0,0,0,0,.78c1.1.89,1.32,2.36,2.34,3.35,1.29,1.23.39,4.33-1.41,5.08a8.3,8.3,0,0,1-1.53.62,1.69,1.69,0,0,0-1.52,1.82c-.07,1.56-1.44,2.62-2.21,3.91-.44.73-.75,1.33-.2,2.05a2.42,2.42,0,0,0,2.06.95c.72,0,.4-.71.37-1.06a4.86,4.86,0,0,1,2.46-4.92,5.41,5.41,0,0,1,5.35-.4,14,14,0,0,1,2.45,1.3C40.39,23.7,40.37,25.69,40,28c-.05.27-.24.5-.07.79a2.25,2.25,0,0,1-.26,2.68c-.63.76-.95,1.7-1.6,2.41-1.57,1.7-.8,2.72,1,3.4,1.67.62,3.44,1.07,4.75,2.43A5.73,5.73,0,0,1,45,41.55a1.07,1.07,0,0,1-.6,1.5c-.62.21-1.06-.12-1.29-.76-.57-1.62-2.06-2-3.44-2.63s-3-.89-4-2.34c-.56-.83-.66-3.3.07-3.92,1-.9,1.27-2.37,2.32-3.25a.34.34,0,0,0,.07-.34c-.88-1.07-.11-2.12,0-3.18.22-1.79-.65-2.76-2.24-3.55a3.92,3.92,0,0,0-4.15.24,3.65,3.65,0,0,0-1.21,4.31c.14.34.39.7.26,1-.8,2,.79,3.25,1.74,4.49C34,35,33.42,38,31.23,38.73c-1.23.42-2.42.94-3.62,1.44a3.47,3.47,0,0,0-2.07,2c-.27.73-.69,1.19-1.41.87a1.2,1.2,0,0,1-.45-1.78,6,6,0,0,1,3.25-3c1.17-.45,2.34-.91,3.48-1.44s1.14-1.18.59-2.18c-.83-1.54-2.09-2.81-2.67-4.54-.28-.83-1.51-.72-2.29-1.07-2.12-.94-2.85-2.16-2.48-4.43a1.67,1.67,0,0,1,.72-1c1-.86,1.13-2.32,2.17-3.15a.28.28,0,0,0,0-.24c-.67-1.53.29-3,0-4.57a2,2,0,0,0-.86-1.49,9.68,9.68,0,0,0-2.25-1.23A3.49,3.49,0,0,0,19,17a4,4,0,0,1,.12,1.46c-.32,2.11.82,3.61,2.06,5.05s.46,4.54-1.31,5.36c-.85.4-1.76.69-2.64,1-.18.07-.39,0-.49.28A27,27,0,0,1,14,34.64a1.42,1.42,0,0,0,.57,2.11c1.46.78,3.1,1.12,4.54,1.94a5.52,5.52,0,0,1,2.41,2.77A1.12,1.12,0,0,1,21,43c-.67.28-1.13-.07-1.38-.76-.56-1.56-2-2-3.34-2.58s-3.09-.9-4.08-2.38c-.55-.82-.61-3.29.12-3.93,1-.9,1.27-2.36,2.32-3.24a.28.28,0,0,0,0-.23c-1-1.36.27-2.69,0-4-.18-1.05-.36-2.05-1.7-2.39-.81-.21-1.41-1-2.4-.92C7.54,22.8,6.24,25,7.15,27.77c.19.58.42,1.11-.08,1.66a.6.6,0,0,0,0,.88c1.1,1,1.49,2.44,2.5,3.52,1.15,1.23,0,4.13-1.72,4.86-1.24.51-2.5,1-3.74,1.48a3.47,3.47,0,0,0-2.06,2c-.26.74-.7,1.18-1.42.86S-.1,41.87.21,41.22a5.89,5.89,0,0,1,3.26-3c1.17-.46,2.34-.92,3.48-1.45a1.27,1.27,0,0,0,.54-2.17,26.77,26.77,0,0,0-2-3,2.27,2.27,0,0,1-.57-1.67c.06-1.42.08-2.85,0-4.27-.13-2.6,2.45-4.74,4.9-5,2.1-.25,3.7.8,5.3,1.73a3.33,3.33,0,0,1,1.54,3C16.66,26.16,16.67,27,16.67,28Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">
                  Group/ <span className="text-start">Corporate</span>{" "}
                </span>
              </div>
              <div
                className="col-lg-1 col-3 pol  m-2"
                onClick={() => {
                  navigateTo("/TravelForm");
                }}
              >
                <div className="mb-2 mt-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="insure"
                    viewBox="0 0 56.68 37.57"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M0,12.6c1.3-1.18,2.79-1.82,4.5-1.08a15.39,15.39,0,0,1,2.6,1.72c.87.63,1.68,1.37,2.58,2,1.41.93,2.58-.15,3.76-.63,2.06-.84,4.06-1.83,6.21-2.81-.94-1.22-2.44-1.69-3.65-2.54a47,47,0,0,1-4.34-2.78c-1.35-1.16-1.3-2.06.2-3a8,8,0,0,1,6.93-.63c2.11.65,4.23,1.24,6.35,1.87,1.48.44,3,.86,4.45,1.38a3.64,3.64,0,0,0,3-.11,124.6,124.6,0,0,1,11.49-5c3.57-1.29,7.29-1.41,10.67.87,2.42,1.63,2.5,3.22.32,4.85-3.28,2.46-7,4.1-10.6,5.94-1.22.63-2.47,1.19-3.72,1.75-.74.33-.79,1.11-1.07,1.68q-4,8.5-7.93,17.07a8.52,8.52,0,0,1-4.92,4.36,1.55,1.55,0,0,1-1.7-.31,2.23,2.23,0,0,1-.68-2.41c.51-1.84.68-3.75,1.12-5.59.56-2.38.67-4.86,1.49-7.19a1.94,1.94,0,0,0,0-1.32,98,98,0,0,1-11.15,4.32,26,26,0,0,1-5.58,1.15c-3.49.27-5.59-.52-6.94-4.23-.86-2.35-2.19-4.5-3-6.87,0-.08-.25-.08-.39-.12ZM27.31,34.54a4.35,4.35,0,0,0,2.16-2.11c.85-1.81,1.67-3.64,2.51-5.45,1.82-3.9,3.61-7.82,5.47-11.69.55-1.15.86-2.49,2.24-3.09,1.73-.76,3.45-1.57,5.14-2.42a75.14,75.14,0,0,0,8.3-4.56c.9-.6.81-1.15-.09-1.69-2.66-1.64-5.5-1.42-8.18-.35-4.74,1.88-9.32,4.12-14,6.14-6.11,2.62-12.13,5.49-18.17,8.28a4.07,4.07,0,0,1-4.77-.7A33.75,33.75,0,0,0,4.2,14.13c-.55-.34-1-.62-1.46-.25s0,.89.21,1.26c1,2.36,2.2,4.67,3.22,7A1.87,1.87,0,0,0,7.9,23.45a21.14,21.14,0,0,0,9.2-1.36A115.59,115.59,0,0,0,29.45,17c1.08-.51.71,0,.67.54a65.29,65.29,0,0,1-1.4,8.12c-.26,1.33-.47,2.74-.77,4.08S26.9,32.73,27.31,34.54ZM16,4.63c-.57.15-1.48-.28-1.65.34s.75,1,1.25,1.26c1.86,1,3.66,2.18,5.46,3.31.84.52,1.67,1.2,2.88.35a14.44,14.44,0,0,1,2.57-1.2c.31-.14.83,0,.7-.63s-.51-.45-.86-.57c-1.65-.55-3.33-1-5-1.5S17.89,4.66,16,4.63Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Travel</span>
              </div>
              <div
                className=" col-lg-1 col-3 pol m-2"
                onClick={() => {
                  navigateTo("/PersonalLoan");
                }}
              >
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="insure"
                    viewBox="0 0 49.99 58.69"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M4.76,58.69c0-.14,0-.38-.06-.41C1.22,56.78,0,54,0,50.39,0,46,1.68,42.31,3.89,38.76a115.57,115.57,0,0,1,7.84-11.64c1.72-2.13,3.76-3.73,6.74-3.64A23.2,23.2,0,0,0,24,23.26,12.79,12.79,0,0,1,17.08,18a10.94,10.94,0,0,1-1.6-8.67c1.34-5.63,6-10.13,13.21-9.26a11.26,11.26,0,0,1,10,9.61c1,6.23-2.38,11.47-8.54,13.78,2.05,0,4.1,0,6.15,0a8.18,8.18,0,0,1,5,1.75c2.55,1.88,4,4.54,5.12,7.39a48.83,48.83,0,0,1,2.75,10.77c.49,2.94,1.11,6,.68,9-.35,2.51-1.09,4.86-3.43,6.3Zm16.86-2.34c3,0,6.06,0,9.08,0,1,0,1.12-.32,1.07-1.18s-.55-1.22-.6-1.93a32.44,32.44,0,0,0-1.34-6c-1-3.58-1.65-7.23-2.68-10.8-.81-2.79-1.26-5.68-1.92-8.52-.48-2.1-.52-2.09-2.72-2.09a35.41,35.41,0,0,0-4.25,0c-1.81.22-3.5.81-4.26,2.76s-1.19,3.8-1.78,5.69a55.28,55.28,0,0,0-2.06,9.07A30.8,30.8,0,0,0,10,52.94c.41,2.3,1.49,3.41,3.86,3.41Zm18.25,0a37.65,37.65,0,0,1,4.15,0,2.46,2.46,0,0,0,2.86-2,7.77,7.77,0,0,0,.49-3.86c-.57-2.42-.27-4.89-.8-7.34a63.31,63.31,0,0,0-2.52-9.81c-1-2.54-2.18-5-4.7-6.45-3.87-2.19-8-.63-12.1-1.16.36,1.73.63,3.22,1,4.68.86,3.43,1.75,6.85,2.43,10.32a1.7,1.7,0,0,0,2.1,1.52,8.75,8.75,0,0,1,4.39.52c2.57,1.06,5.05,4.25,5.17,7.05A9,9,0,0,1,39.87,56.35ZM27,21.15c5.42-.33,9.3-4,9.34-9.34A9.05,9.05,0,0,0,27.1,2.44a9.1,9.1,0,0,0-9.37,9.29C17.72,17.14,21.72,20.82,27,21.15ZM8.52,36C7.35,37.88,6.06,39.72,5,41.7,3.38,44.79,2,48,2.43,51.63c.33,2.82,2.12,4.85,5.07,4.74.92,0,1-.5.73-1.08a11.22,11.22,0,0,1-.66-2.64c-1.08-3.79,0-7.48.43-11.21C8.22,39.65,9.13,38,8.52,36Zm25,8.63c-.53.31-2.2-.76-1.63,1.21.87,3.06,1.63,6.15,2.24,9.27.13.63.45,1.16,1.07,1.09,2.2-.22,4.63-3,4.78-5.33A6.22,6.22,0,0,0,33.49,44.61Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Personal Accident</span>
              </div>
              <div
                className=" col-lg-1 col-3 pol m-2"
                onClick={() => {
                  navigateTo("/CreditCardForm1");
                }}
              >
                <div className="mb-2 mt-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="insure"
                    viewBox="0 0 61.35 52.41"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M47.94,52.41c-1.74-1.55-3.83-2.67-5.38-4.49A26,26,0,0,1,37,38a35.11,35.11,0,0,1-1.27-7.89c-.07-1.48.52-2.22,1.69-2.37,2.89-.35,5.33-1.82,8-2.85a8.8,8.8,0,0,1,7.55.47,31.31,31.31,0,0,0,8.41,2.81v5.75c-1.16,1-.74,2.57-1.12,3.83a26.81,26.81,0,0,1-6.63,11.1,47.52,47.52,0,0,1-4.38,3.59Zm.63-25.56a6.35,6.35,0,0,0-2.09.41A28.63,28.63,0,0,1,39.79,30c-1.21.22-1.6.67-1.38,1.73a40.48,40.48,0,0,0,1.78,7.4,20.5,20.5,0,0,0,7.45,9.65c.89.61,1.28.38,2-.12a22.15,22.15,0,0,0,5.71-6.41A26.67,26.67,0,0,0,58.73,31.7c.1-.61.33-1.47-.73-1.62-1.83-.26-3.39-1.23-5.08-1.82C51.49,27.76,50.29,26.48,48.57,26.85Z" />
                        <path d="M29.47,15.36c-8.46,0-16.93,0-25.39,0-1.13,0-1.55.2-1.53,1.46.07,5.75.1,11.49,0,17.24A4.37,4.37,0,0,0,6.94,38.4c8.73-.08,17.46,0,26.18,0,.51,0,1.1-.29,1.53.46.32.59.68,1.16.45,1.76s-.93.29-1.42.3c-9.1,0-18.19-.07-27.29.05A6.79,6.79,0,0,1,0,34.6Q.17,20.47,0,6.35A6.79,6.79,0,0,1,6.39,0Q29.45.14,52.52,0c3.17,0,6.36,3.18,6.3,6.26-.11,5.74,0,11.49,0,17.23,0,.47.37,1.48-.48,1.33s-2.08-.07-2-1.56c0-2.18-.06-4.36,0-6.54,0-1.15-.34-1.4-1.43-1.4C46.39,15.38,37.93,15.36,29.47,15.36ZM29.34,9h7.34c6.07,0,12.13,0,18.2,0,.48,0,1.25.4,1.36-.58.34-3-.72-5.81-4.48-5.81q-22.35,0-44.69,0A4.07,4.07,0,0,0,2.89,5.13a5,5,0,0,0-.16,3.54C3,9.41,4.27,9,5.08,9Q17.22,9,29.34,9Z" />
                        <path d="M19.24,21.75c-3,0-6.06-.05-9.08,0C9.1,21.8,9,21.38,9,20.48s.15-1.31,1.2-1.3q9.09.08,18.16,0c1.18,0,1.08.59,1.12,1.37s-.14,1.24-1.11,1.22C25.29,21.71,22.26,21.75,19.24,21.75Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6">Credit Card</span>
              </div>
              <div
                className=" col-lg-1 col-9 pol m-2"
                onClick={() => {
                  navigateTo("/LoanForm");
                }}
              >
                <div className="mb-2 mt-2 ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-2 insure"
                    viewBox="0 0 61.3 64.15"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M44.25,18c.55,1.53,2,1.16,3,1.71a22.66,22.66,0,0,1,3.25,2.45,1.47,1.47,0,0,1,.31,2.11,1.46,1.46,0,0,1-2.11-.08,12,12,0,0,0-4.89-2.68,9.07,9.07,0,0,0-3.23-.19c1.51,1.45,3.2,2.07,4.62,3.08A29.06,29.06,0,0,1,56.34,39.22c.5,1.52,1.72,2.32,2.53,3.51a13.65,13.65,0,0,1-6.2,20.42,13.31,13.31,0,0,1-11.61-.75,1.91,1.91,0,0,0-1.38-.35c-4,1.08-8,.42-12,.57a47.6,47.6,0,0,1-7.46-.09C15.71,62,11.07,61.69,7,59.27a13.1,13.1,0,0,1-6.35-8.5A29.21,29.21,0,0,1,0,45.45c-.29-4.62,1.39-8.73,3.66-12.52a27.54,27.54,0,0,1,10.7-10.55,9.08,9.08,0,0,1,1-.53c2.53-1,3.08-2.88,2-5.52a19.53,19.53,0,0,0-4.15-5.88A11.14,11.14,0,0,1,12.12,9C10.81,7.2,12,5.61,13.64,4.89a13.38,13.38,0,0,1,5.65-.64,4,4,0,0,0,3.36-1.71c2.54-3.06,4.72-3.46,7.84-.62A5,5,0,0,0,36.3,3a7,7,0,0,1,3.53-.12C41.43,3.19,42,5.26,41.16,7c-1,2.22-2.66,4.1-3.41,6.5a10.37,10.37,0,0,0-.4,3.63c.06,1.24.85.53,1.41.23,2.45-1.3,4.91-2.51,7.83-2.35a12.45,12.45,0,0,1,4.73,1.34c1.14.53,1.42,1.43.9,2.32s-1.57.58-2.28.19a8.14,8.14,0,0,0-5.11-1.07A5.61,5.61,0,0,0,44.25,18ZM28.06,59.87c2.22,0,4.09,0,5.95,0,3-.07,2.82-.16,1.72-2.83-1-2.37-2-3.41-4.74-3.47-2.38-.05-4.68-1.67-7.23-.4-.85.42-1.24-.45-1.68-1s.07-1,.46-1.33a7.3,7.3,0,0,0,2.28-3.51,5.81,5.81,0,0,0-.14-2.54c-.17-1.57-1.17-1.17-2.05-1.21-.42,0-.81,0-.81-.6,0-.33-.08-.71.39-.8,1.16-.19.77-.57.48-1.45-.66-2-1-4,.12-6.1,1.51-2.73,3.91-3.32,6.74-3.25A6.47,6.47,0,0,1,36,37.23c.06.66.53,1.7-.85,1.76-1,0-1.78.14-1.89-1.37a3.75,3.75,0,0,0-2.38-3.48,4.64,4.64,0,0,0-4.84.72c-1.17,1.08-1,2.52-.89,3.91.19,2.6,1.06,3.42,3.61,3.42.56,0,1.13,0,1.7,0,.38,0,.81,0,.78.62s-.3.7-.75.71c-.8,0-1.59,0-2.38,0-.62,0-1.16.24-.73.86.79,1.14.23,2.11-.12,3.16s.67,2.46,1.7,2.94a10,10,0,0,0,3.79.65c.87.05,1.4-.17,1.31-1.22a10.64,10.64,0,0,1,1.28-5.41c2.58-5.77,9.68-9.29,15.94-7.19.31.1.7.26,1,0s0-.62-.12-.91a29.62,29.62,0,0,0-14.26-13.1c-.68-.31-1.6-1-2.32-.64a25.31,25.31,0,0,1-4.21,1.39,17,17,0,0,1-8.43,0c-2-.5-3.89-1.12-6.11.12a27.45,27.45,0,0,0-9.53,8.47,23.31,23.31,0,0,0-4.52,13.4,24.38,24.38,0,0,0,.68,4.13A8.8,8.8,0,0,0,6.7,55.77a17.18,17.18,0,0,0,9.39,3.36C20.17,59.53,24.26,60.35,28.06,59.87Zm30.43-9.46c-.32-6.13-4.73-10.84-10.92-10.8a10.8,10.8,0,0,0,0,21.6C53.76,61.23,58.16,56.58,58.49,50.41Zm-24-37.86c-3.59,2-5.42,1.24-7.18-.45-1.49-1.44-1.91-1.54-3.39-.18-1,.95-2,1.84-3.56,1.8-.84,0-.8.61-.59,1a10.89,10.89,0,0,1,1.27,5.11,1.26,1.26,0,0,0,1,1.24,16.1,16.1,0,0,0,10.22-.06,2.22,2.22,0,0,0,1.83-2.74,6.09,6.09,0,0,1,.47-4A1.94,1.94,0,0,0,34.54,12.55Zm2.83-6.12a4,4,0,0,0-2.47-.17,7.2,7.2,0,0,1-6.14-2c-2.35-2.09-2.12-1.89-4,.17C23.35,6,21.88,7.16,19.67,7c-1.15-.09-2.2.43-3.32.48-.55,0-.85.2-.64.84.69,2.12,4.5,3.25,6.1,1.76A7.94,7.94,0,0,1,24.32,8.3a4,4,0,0,1,4.92,1.61c1.06,1.42,2.13,1.29,3.34.34C34.12,9,35.65,7.81,37.37,6.43Z" />
                        <path d="M53.76,45.91c0,.52-.45.77-.74,1.07-2.94,3-5.9,5.93-8.86,8.88-.65.64-1.16,1-2.07.09s-.59-1.4.07-2.06c3-3,6-6,9-9,.37-.37.78-1,1.42-.51S53.68,45.15,53.76,45.91Z" />
                        <path d="M46.25,46.35A2.7,2.7,0,0,1,43.43,49a2.64,2.64,0,0,1-2.6-2.73,2.71,2.71,0,1,1,5.42,0Z" />
                        <path d="M49,54.35a2.71,2.71,0,1,1,2.49,2.85A2.71,2.71,0,0,1,49,54.35Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6 mb-2">Loan</span>
              </div>


              <div
                className=" col-lg-1 col-9 pol m-2"
                onClick={() => {
                  navigateTo("/emi");
                }}
              >
                <div className="mb-2 mt-2 ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-2 insure"
                    viewBox="0 0 61.3 64.15"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path d="M44.25,18c.55,1.53,2,1.16,3,1.71a22.66,22.66,0,0,1,3.25,2.45,1.47,1.47,0,0,1,.31,2.11,1.46,1.46,0,0,1-2.11-.08,12,12,0,0,0-4.89-2.68,9.07,9.07,0,0,0-3.23-.19c1.51,1.45,3.2,2.07,4.62,3.08A29.06,29.06,0,0,1,56.34,39.22c.5,1.52,1.72,2.32,2.53,3.51a13.65,13.65,0,0,1-6.2,20.42,13.31,13.31,0,0,1-11.61-.75,1.91,1.91,0,0,0-1.38-.35c-4,1.08-8,.42-12,.57a47.6,47.6,0,0,1-7.46-.09C15.71,62,11.07,61.69,7,59.27a13.1,13.1,0,0,1-6.35-8.5A29.21,29.21,0,0,1,0,45.45c-.29-4.62,1.39-8.73,3.66-12.52a27.54,27.54,0,0,1,10.7-10.55,9.08,9.08,0,0,1,1-.53c2.53-1,3.08-2.88,2-5.52a19.53,19.53,0,0,0-4.15-5.88A11.14,11.14,0,0,1,12.12,9C10.81,7.2,12,5.61,13.64,4.89a13.38,13.38,0,0,1,5.65-.64,4,4,0,0,0,3.36-1.71c2.54-3.06,4.72-3.46,7.84-.62A5,5,0,0,0,36.3,3a7,7,0,0,1,3.53-.12C41.43,3.19,42,5.26,41.16,7c-1,2.22-2.66,4.1-3.41,6.5a10.37,10.37,0,0,0-.4,3.63c.06,1.24.85.53,1.41.23,2.45-1.3,4.91-2.51,7.83-2.35a12.45,12.45,0,0,1,4.73,1.34c1.14.53,1.42,1.43.9,2.32s-1.57.58-2.28.19a8.14,8.14,0,0,0-5.11-1.07A5.61,5.61,0,0,0,44.25,18ZM28.06,59.87c2.22,0,4.09,0,5.95,0,3-.07,2.82-.16,1.72-2.83-1-2.37-2-3.41-4.74-3.47-2.38-.05-4.68-1.67-7.23-.4-.85.42-1.24-.45-1.68-1s.07-1,.46-1.33a7.3,7.3,0,0,0,2.28-3.51,5.81,5.81,0,0,0-.14-2.54c-.17-1.57-1.17-1.17-2.05-1.21-.42,0-.81,0-.81-.6,0-.33-.08-.71.39-.8,1.16-.19.77-.57.48-1.45-.66-2-1-4,.12-6.1,1.51-2.73,3.91-3.32,6.74-3.25A6.47,6.47,0,0,1,36,37.23c.06.66.53,1.7-.85,1.76-1,0-1.78.14-1.89-1.37a3.75,3.75,0,0,0-2.38-3.48,4.64,4.64,0,0,0-4.84.72c-1.17,1.08-1,2.52-.89,3.91.19,2.6,1.06,3.42,3.61,3.42.56,0,1.13,0,1.7,0,.38,0,.81,0,.78.62s-.3.7-.75.71c-.8,0-1.59,0-2.38,0-.62,0-1.16.24-.73.86.79,1.14.23,2.11-.12,3.16s.67,2.46,1.7,2.94a10,10,0,0,0,3.79.65c.87.05,1.4-.17,1.31-1.22a10.64,10.64,0,0,1,1.28-5.41c2.58-5.77,9.68-9.29,15.94-7.19.31.1.7.26,1,0s0-.62-.12-.91a29.62,29.62,0,0,0-14.26-13.1c-.68-.31-1.6-1-2.32-.64a25.31,25.31,0,0,1-4.21,1.39,17,17,0,0,1-8.43,0c-2-.5-3.89-1.12-6.11.12a27.45,27.45,0,0,0-9.53,8.47,23.31,23.31,0,0,0-4.52,13.4,24.38,24.38,0,0,0,.68,4.13A8.8,8.8,0,0,0,6.7,55.77a17.18,17.18,0,0,0,9.39,3.36C20.17,59.53,24.26,60.35,28.06,59.87Zm30.43-9.46c-.32-6.13-4.73-10.84-10.92-10.8a10.8,10.8,0,0,0,0,21.6C53.76,61.23,58.16,56.58,58.49,50.41Zm-24-37.86c-3.59,2-5.42,1.24-7.18-.45-1.49-1.44-1.91-1.54-3.39-.18-1,.95-2,1.84-3.56,1.8-.84,0-.8.61-.59,1a10.89,10.89,0,0,1,1.27,5.11,1.26,1.26,0,0,0,1,1.24,16.1,16.1,0,0,0,10.22-.06,2.22,2.22,0,0,0,1.83-2.74,6.09,6.09,0,0,1,.47-4A1.94,1.94,0,0,0,34.54,12.55Zm2.83-6.12a4,4,0,0,0-2.47-.17,7.2,7.2,0,0,1-6.14-2c-2.35-2.09-2.12-1.89-4,.17C23.35,6,21.88,7.16,19.67,7c-1.15-.09-2.2.43-3.32.48-.55,0-.85.2-.64.84.69,2.12,4.5,3.25,6.1,1.76A7.94,7.94,0,0,1,24.32,8.3a4,4,0,0,1,4.92,1.61c1.06,1.42,2.13,1.29,3.34.34C34.12,9,35.65,7.81,37.37,6.43Z" />
                        <path d="M53.76,45.91c0,.52-.45.77-.74,1.07-2.94,3-5.9,5.93-8.86,8.88-.65.64-1.16,1-2.07.09s-.59-1.4.07-2.06c3-3,6-6,9-9,.37-.37.78-1,1.42-.51S53.68,45.15,53.76,45.91Z" />
                        <path d="M46.25,46.35A2.7,2.7,0,0,1,43.43,49a2.64,2.64,0,0,1-2.6-2.73,2.71,2.71,0,1,1,5.42,0Z" />
                        <path d="M49,54.35a2.71,2.71,0,1,1,2.49,2.85A2.71,2.71,0,0,1,49,54.35Z" />
                      </g>
                    </g>
                  </svg>
                </div>
                <span className="fs-6 mb-2">EMi</span>
              </div>





            </div>

            <div>
              <hr style={{ height: "2px", borderWidth: "2px" }} />
            </div>
          </div>

          {/* Coverage trail */}
          <div class="container my-5 		d-none d-sm-block">
            <h2 class="section-heading">Coverage Tailored to Fit Your Life</h2>
            <div class="row justify-content-center">
              <div class="col-md-4 col-sm-6 mb-4">
                <div class="">
                  <div class="">
                    <img src={HealthCoverage} alt="Health Icon" />
                  </div>
                  <h5 class="card-title ">Health Insurance</h5>
                  <p class="card-text">
                    Access quality healthcare without the high costs. Find plans
                    for individuals, families, and businesses.
                  </p>
                  <div
                    class="btn-custom"
                    onClick={() => {
                      navigateTo("/HealthForm1");
                    }}
                  >
                    Check Prices
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 mb-4">
                <div class="">
                  <div className="mb-4">
                    <img src={Lifecoverage} alt="Life Icon" />
                  </div>
                  <h5 class="card-title mt-4">Life Insurance</h5>
                  <p class="card-tex mb-4">
                    Protect your family’s future with flexible life insurance
                    policies designed for lasting security.
                  </p>
                  <div
                    class="btn-custom"
                    onClick={() => {
                      navigateTo("/GroupInsurance");
                    }}
                  >
                    Check Prices
                  </div>
                </div>
              </div>

              <div class="col-md-4 col-sm-6 mb-4">
                <div class="">
                  <div className="mb-5">
                    <img src={CarCoverage} alt="Car Icon" />
                  </div>
                  <h5 class="card-title">Car Insurance</h5>
                  <p class="card-text">
                    Drive with confidence. Our auto policies cover accidents,
                    repairs, and more.
                  </p>
                  <div
                    class="btn-custom"
                    onClick={() => {
                      navigateTo("/CarForm/1");
                    }}
                  >
                    Check Prices
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* mobile view */}
          <div className="container d-block d-lg-none">
            <h2 class="section-heading">Coverage Tailored to Fit Your Life</h2>
            <div className="row">
              <div className="col-12">
                <div
                  id="mobileCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <div className="mobile-card text-center">
                        <div className="mobile-icon-container mb-3">
                          <img src={HealthCoverage} alt="Health Icon" />
                        </div>
                        <h5 className="mobile-card-title">Health Insurance</h5>
                        <p className="mobile-card-text">
                          Access quality healthcare without the high costs. Find
                          plans for individuals, families, and businesses.
                        </p>
                        <div
                          class="btn-custom"
                          onClick={() => {
                            navigateTo("/HealthForm1");
                          }}
                        >
                          Check Prices
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="mobile-card text-center">
                        <div className="mobile-icon-container mb-3">
                          <img src={Lifecoverage} alt="Life Icon" />
                        </div>
                        <h5 className="mobile-card-title">Life Insurance</h5>
                        <p className="mobile-card-text">
                          Protect your family’s future with flexible life
                          insurance policies designed for lasting security.
                        </p>
                        <div
                          class="btn-custom"
                          onClick={() => {
                            navigateTo("/GroupInsurance");
                          }}
                        >
                          Check Prices
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div className="mobile-card text-center">
                        <div className="mobile-icon-container mb-3">
                          <img src={CarCoverage} alt="Car Icon" />
                        </div>
                        <h5 className="mobile-card-title">Car Insurance</h5>
                        <p className="mobile-card-text">
                          Drive with confidence. Our auto policies cover
                          accidents, repairs, and more.
                        </p>
                        <div
                          class="btn-custom"
                          onClick={() => {
                            navigateTo("/CarForm/1");
                          }}
                        >
                          Check Prices
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#mobileCarousel"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#mobileCarousel"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* OUr Partners */}

          <div className="container mt-5 mb-5 	d-none d-sm-block">
            <div className="row ">
              <div className="col-12 mt-3">
                <div className="">
                  <h1 className="mb-1">Our Partners</h1>
                  <p className="mb-5 fs-4" style={{ color: "#A7A8AC" }}>
                    Your Shield, Our Network
                  </p>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-12 ">
                  <div className="baner">
                    <img
                      src={Banner}
                      style={{ height: "100%", width: "100%" }}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <hr style={{ height: "2px", borderWidth: "2px" }} />
            </div>
          </div>
          {/* mobile view */}
          <div className="container d-block d-sm-none">
            <div className="row  mt-5 py-5s">
              <div className="col-12 mt-3">
                <div className="">
                  <h1 className="mb-1">Our Partners</h1>
                  <p className="mb-5 fs-4" style={{ color: "#A7A8AC" }}>
                    Your Shield, Our Network
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div
                  id="carouselExampleFade"
                  class="carousel slide carousel-fade"
                >
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img
                        src={Pattners1}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src={Pattners2}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src={Pattners3}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src={Pattners4}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src={Pattners5}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        src={Pattners6}
                        class="d-block w-50 mx-auto"
                        alt="..."
                      />
                    </div>
                  </div>
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleFade"
                    data-bs-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleFade"
                    data-bs-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* trust us */}
          <div className="container mt-5 py-5">
            {/* Heading Section */}
            <div className="row mb-5">
              <div className="col-sm-12 text-center w-50 mx-auto">
                <h3 className="fw-bold ">
                  Why Thousands Trust Us for Their Insurance Needs
                </h3>
              </div>
            </div>

            {/* Cards Section */}
            <div className="row justify-content-center">
              {/* Card 1 */}
              <div className="col-md-4 col-sm-6 col-10 mb-4">
                <div className="card text-center shadow p-4">
                  <div className="iconss-container mx-auto">
                    <img
                      src={PP}
                      alt="Personalized Plans Icon"
                      className="iconss"
                    />
                  </div>
                  <h5 className="cardss-title fw-bold">Personalized Plans</h5>
                  <p className="cardss-text text-muted">
                    We design policies to meet your unique lifestyle and budget.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-md-4 col-sm-6 col-10 mb-4">
                <div className="card text-center shadow p-4">
                  <div className="iconss-container mx-auto">
                    <img src={TT} alt="Track Record Icon" className="iconss" />
                  </div>
                  <h5 className="cardss-title fw-bold">Proven Track Record</h5>
                  <p className="cardss-text text-muted">
                    A proven track record with thousands of satisfied clients.
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="col-md-4 col-sm-6 col-10 mb-4">
                <div className="card text-center shadow p-4">
                  <div className="iconss-container mx-auto">
                    <img src={support} alt="Support Icon" className="iconss" />
                  </div>
                  <h5 className="cardss-title fw-bold">Dedicated Support</h5>
                  <p className="cardss-text text-muted">
                    Access claims support, answers, and guidance whenever you
                    need it.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Testinomial */}

          <div className="testimony-container">
            <div className="container">
              {/* Navigation */}
              <div className="testimony-navigation">
                <span>&lt;&lt;</span> Customers Testimony <span>&gt;&gt;</span>
              </div>

              {/* Title */}
              <h2 className="testimony-title">
                See What They Are Talking About?
              </h2>

              {/* Carousel */}
              <div
                id="testimonialCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval="5000" // Auto-advance every 5 seconds
              >
                <div className="carousel-inner">
                  {groupedTestimonials.map((group, index) => (
                    <div
                      key={index}
                      className={`carousel-item ${index === 0 ? "active" : ""}`}
                    >
                      <div className="row justify-content-center">
                        {group.map((testimony, idx) => (
                          <div
                            key={idx}
                            className="col-md-4 col-sm-6 mb-4 d-flex justify-content-center"
                          >
                            <div className="testimony-card">
                              <h5>{testimony.name}</h5>
                              <p>{testimony.feedback}</p>
                              <div className="rating">
                                {Array.from(
                                  { length: testimony.rating },
                                  (_, i) => (
                                    <i key={i} className="bi bi-star-fill"></i>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Carousel Controls */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#testimonialCarousel"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
          {/* FAQ Section */}

          <div className="container px-5 mt-5  ">
            <div className="row px-5 mb-5 ps-5">
              <div className="col-lg-12">
                <h5 style={{ textAlign: "justify" }} className="fs-1 ">
                  FAQ
                </h5>
              </div>
            </div>

            <div className="row px-5 ps-5">
              <div className="col-lg-12  ">
                <div className="row ">
                  <div className="col-lg-12">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          Why do I need insurance?
                        </Accordion.Header>
                        <Accordion.Body>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          How is insurance premium calculated?
                        </Accordion.Header>
                        <Accordion.Body>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          What is a waiting period in insurance?
                        </Accordion.Header>
                        <Accordion.Body>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="4">
                        <Accordion.Header>
                          How do I file an insurance claim?
                        </Accordion.Header>
                        <Accordion.Body>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="5">
                        <Accordion.Header>
                          Can I customize my insurance coverage?
                        </Accordion.Header>
                        <Accordion.Body>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua. Ut enim ad minim veniam, quis
                          nostrud exercitation ullamco laboris nisi ut aliquip
                          ex ea commodo consequat. Duis aute irure dolor in
                          reprehenderit in voluptate velit esse cillum dolore eu
                          fugiat nulla pariatur. Excepteur sint occaecat
                          cupidatat non proident, sunt in culpa qui officia
                          deserunt mollit anim id est laborum.
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </div>

              {/* <div className='col-lg-4 	d-none d-sm-block'>
                            <div>
                                <img src={question} alt="" />
                            </div>
                        </div> */}
            </div>
          </div>

          {/* contact us */}
          <div id="Contact">
            <div className="container  mt-5 mb-5 ">
              <div className="row ps-4 ">
                <div className="col-lg-12 mt-5 mb-5">
                  <h5 style={{ textAlign: "justify" }} className="fs-1">
                    Contact Us
                  </h5>
                </div>
              </div>

              <div className="row p-3 ">
                <div className="col-lg-4 text-start ">
                  <label for="" class="form-label fs-4">
                    First Name
                  </label>
                  <input
                    type="text"
                    class="form-control h-50"
                    id=""
                    placeholder="Enter Your First Name"
                    name="First_Name"
                    value={contact_form.First_Name}
                    onChange={(e) => {
                      addValues(e);
                    }}
                  />
                </div>

                <div className="col-lg-4 text-start ">
                  <label for="formGroupExampleInput" class="form-label fs-4">
                    Last Name
                  </label>
                  <input
                    type="text"
                    class="form-control h-50"
                    id="formGroupExampleInput"
                    placeholder="Enter Your Last Name"
                    name="Last_Name"
                    value={contact_form.Last_Name}
                    onChange={(e) => {
                      addValues(e);
                    }}
                  />
                </div>

                <div className="col-lg-4 text-start ">
                  <label for="formGroupExampleInput" class="form-label fs-4">
                    Contact
                  </label>
                  <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">
                      +91
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Your Contact Number"
                      aria-label=""
                      aria-describedby="basic-addon1"
                      maxLength={"10"}
                      onKeyPress={handleNumericOnly}
                      name="Contact_Number"
                      value={contact_form.Contact_Number}
                      onChange={(e) => {
                        addValues(e);
                      }}
                    />
                  </div>
                </div>

                {/* <div className='col-lg-3 text-start   order-lg-0 order-2 '>
                            <div className="row p-3 ps-5 text-center ">
                                <div className='col-3   text-center'>
                                    <img src={message} alt="" style={{width:"2vw"}} />
                                </div>
                                <div className='col-3  text-center'>
                                    <img src={facebook} alt="" style={{width:"1vw"}}/>
                                </div>
                                <div className='col-3 text-center '>
                                    <img src={X} alt="" style={{width:"2vw"}}/>
                                </div>
                            </div>
                        </div> */}
                {/* </div> */}

                {/* <div className='row mt-5 ms-5'> */}
                <div className="col-lg-4 mt-4 text-start ">
                  <label for="formGroupExampleInput" class="form-label fs-4">
                    Email
                  </label>
                  <input
                    type="text"
                    class="form-control h-50"
                    id="formGroupExampleInput"
                    placeholder="Enter Your Email Address"
                    name="Email_Address"
                    value={contact_form.Email_Address}
                    onChange={(e) => {
                      addValues(e);
                    }}
                  />
                </div>

                <div className="col-lg-4 mt-4 text-start ">
                  <label for="formGroupExampleInput" class="form-label fs-4 ">
                    Learn More About
                  </label>
                  <select
                    class="form-select h-50"
                    aria-label="Default select example"
                    name="Learn_More_About"
                    value={contact_form.Learn_More_About}
                    onChange={(e) => {
                      addValues(e);
                    }}
                  >
                    <option selected>Select Policy </option>
                    <option value="Car insurance">Car insurance</option>
                    <option value="Bike Insurance">Bike Insurance</option>
                    <option value="Health Insurance">Health Insurance</option>
                    <option value="Term Life Insurance">
                      Term Life Insurance
                    </option>
                    <option value="Group And Corporate Insurance">
                      Group And Corporate Insurance
                    </option>
                    <option value="Travel Insurance">Travel Insurance</option>
                    <option value="Personal Accident Insurance">
                      Personal Accident Insurance
                    </option>
                    <option value="Credt Card Insurance">
                      Credt Card Insurance
                    </option>
                    <option value="Loan Insurance">Loan Insurance</option>
                  </select>
                </div>

                <div className="col-lg-3 mt-5 h-150 ">
                  <button
                    className="butsub w-50 h-100 order-1"
                    onClick={handlesubmit1}
                  >
                    Lets Connect
                  </button>
                </div>
                {/* <div className='col-lg-2 text-start   order-lg-0 order-2 '>
                            <div className="row p-3  text-center ">
                                <div className='col-3   text-center'>
                                    <img src={message} alt="" style={{width:"2vw"}} />
                                </div>
                                <div className='col-3  text-center'>
                                    <img src={facebook} alt="" style={{width:"1vw"}}/>
                                </div>
                                <div className='col-3 text-center '>
                                    <img src={X} alt="" style={{width:"2vw"}}/>
                                </div>
                            </div>
                        </div> */}
              </div>
            </div>
          </div>

          <footer className="container-fluid backgroundtheme mt-5 ">
            <div className="row p-5">
              {/* Logo Section */}
              <div className="col-md-7 text-center text-md-start mb-4 mb-md-0">
                <div className="mb-3">
                  <img
                    src={Footerlogo}
                    alt="Footer Logo"
                    style={{ maxWidth: "8vw" }}
                    className="footerlog"
                  />
                </div>
                <div className=" justify-content-center align-items-center w-50 d-none d-sm-block">
                  <span className="text-white">
                    Trust us for peace of mind and reliable protection, backed
                    by our unwavering commitment to your satisfaction and
                    security.
                  </span>
                </div>
                <div className=" justify-content-center align-items-center d-block d-sm-none">
                  <span className="text-white">
                    Trust us for peace of mind and reliable protection, backed
                    by our unwavering commitment to your satisfaction and
                    security.
                  </span>
                </div>
              </div>

              {/* Navigation Links */}
              <div className="col-md-5 mt-4 	d-none d-sm-block">
                <div className="row">
                  {/* First Column */}
                  <div className="col-sm-6 text-center text-sm-start mb-4 mb-sm-0">
                    <ul className="list-unstyled ">
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Home
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        PD Advantages
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Customer Rating
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        About Us
                      </li>
                    </ul>
                  </div>

                  {/* Second Column */}
                  <div className="col-sm-6 text-center text-sm-start">
                    <ul className="list-unstyled ">
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Support
                      </li>
                      <li
                        className="mb-3 fw-bold fs-6"
                        style={{ cursor: "pointer", color: "white" }}
                      >
                        Claim
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>

          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div>
                  <a
                    href="https://unairesync.com/"
                    style={{ color: "black", textDecoration: "none" }}
                    className="fs-6 "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    All Rights Reserved | Developed By UnaireSync
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default Landingpagenew;
